export class RemarkList {
    $id: string;
    RemarkID: number;
    CaseID: any;
    Type: string;
    Reporting?: any;
    Priority: number;
    PrintTC: string;
    CreatedDate: Date;
    CreatedByUserId?: any;

    public constructor(init?: Partial<RemarkList>) {
        Object.assign(this, init);
    }
}
